import { pixelSizeHelper } from '@asset-metrix/portal-ui';

const DESIGN_BASE_FONT_SIZE = 16;
export const BASE_FONT_SIZE = 14;

/** converts figma px values to portal px units */
export const pixelSizeHelperPortalUi = pixelSizeHelper(
  DESIGN_BASE_FONT_SIZE,
  BASE_FONT_SIZE
);
